import React from 'react';

export interface CategoryState {
    categories: ICategory[],
    active?: string
};

const CategoryContext = React.createContext<Record<string, any>>({});
export default CategoryContext;
